import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

// Per Mudassir (May-20 + May-22 update): career-path responses come in
// either of two shapes — components don't care, we just normalize:
//
//   OLD wrapper (May-20):  { isApplicable, message, data: { currentPath, ... } }
//   NEW flat    (May-22):  { hasAlternativeCareerPaths, isAiRecommendationAvailable,
//                            message, alternativePaths, currentPath, employee, ... }
//
// Detection: if a top-level `data` key exists, treat as the old wrapper;
// otherwise the whole response IS the data payload.
//
// Three AI-availability cases (per Mudassir May-22):
//   1. paths exist + AI works     → has=true,  ai=true
//   2. paths exist + AI fails     → has=true,  ai=false   (path AI fields = null)
//   3. no paths in DB             → has=false, ai=false   (empty list)
// Executive-level employees still get isApplicable=false (when present).
const unwrapCareerPathResponse = (raw) => {
  if (raw == null)
    return {
      isApplicable: false,
      hasAlternativeCareerPaths: false,
      isAiRecommendationAvailable: false,
      message: "",
      data: null,
    };
  const hasWrapper = Object.prototype.hasOwnProperty.call(raw, "data");
  return {
    isApplicable: raw.isApplicable !== false,
    hasAlternativeCareerPaths: raw.hasAlternativeCareerPaths !== false,
    isAiRecommendationAvailable: raw.isAiRecommendationAvailable !== false,
    message: raw.message || "",
    data: hasWrapper ? raw.data || null : raw,
  };
};

const employeeService = {
    getEmployees: async() => {
        try {
            const response = await axiosInstance.get(API.employee.getAll(null,null));
            return response.data;
        } catch(error) {
            throw error;
        }
    },

    getEmployeeDetail: async(employeeId) => {
       try{
             const response = await axiosInstance.get(API.employee.employeeGetById(employeeId));
             return response.data ;
       } catch(error){
        throw error;
       }
    },

    getCompensations: async(employeeId) => {
       try{
             const response = await axiosInstance.get(API.employee.getCompensations(employeeId));
             return response.data ;
       } catch(error){
        throw error;
       }
    },

    getEmployement: async(employeeId) => {
       try{
             const response = await axiosInstance.get(API.employee.getEmployment(employeeId));
             return response.data ;
       } catch(error){
        throw error;
       }
    },

    getDirectReports: async(supervisorId) => {
       try{
             const response = await axiosInstance.get(API.employee.getHierDirectReports(supervisorId));
             return response.data ;
       } catch(error){
        throw error;
       }
    },

    getCareerPaths: async(employeeId) =>{
        try{
             const response = await axiosInstance.get(API.careerPaths.getByEmployee(employeeId));
             return unwrapCareerPathResponse(response.data);
        } catch(error){
            throw error;
        }
    },

    getAlternativePaths: async(employeeId) =>{
        try{
             const response = await axiosInstance.get(API.careerPaths.getAlternativePaths(employeeId));
             return unwrapCareerPathResponse(response.data);
        } catch(error){
            throw error;
        }
    },

    // Employee-authorized variants for the Employee Dashboard CareerPath
    // pages (per Mudassir 2026-05-20). Same wrapper handling as the HR-side
    // versions above.
    getMyCareerPath: async () => {
        try {
            const response = await axiosInstance.get(API.careerPaths.getMyCareerPath);
            return unwrapCareerPathResponse(response.data);
        } catch (error) {
            throw error;
        }
    },

    getMyAlternativePaths: async () => {
        try {
            const response = await axiosInstance.get(API.careerPaths.getMyAlternativePaths);
            return unwrapCareerPathResponse(response.data);
        } catch (error) {
            throw error;
        }
    },

    async getPreviousReview(employeeId) {
        const res = await axiosInstance.get(API.performanceReview.getPreviousReview(employeeId));
        return res.data;
      },

    // Full performance-review history for an employee (HR 360 profile tab).
    // Reuses the existing PerformanceEvaluation/Employee/Performance-Reviews endpoint.
    async getPerformanceReviews(employeeId) {
        const res = await axiosInstance.get(API.performanceReview.getPerformanceReviews(employeeId));
        return res.data;
      },

    getSupervisors : async ( employeeId, jobTitleId) => {
        try{
                 const response = await axiosInstance.get(API.careerPaths.getSupervisors(employeeId,jobTitleId))
                 return response.data;
        } catch(error){
            throw error;
        }
    },

      createTransition : async(paylaod) => {
        try{
             const response = await axiosInstance.post(API.careerPaths.createTransitions, paylaod);
             return response.data;
        } catch( error ){
            throw error ;
        }
    }


}

// Use a default export
export default employeeService;